export default "__VITE_ASSET__h3piQUo___"